import { TradeDetailsProvider } from '@paradigm/features/src/unified-rfqs/ui/trades/trade-details-context';
import { GrfqTradeProvider } from '@paradigm/features/src/unified-rfqs/ui/trade-context';

import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';

import { useMaybeTradeTapeItem } from '@paradigm/features/src/unified-rfqs/contexts/unified-trade-tapes';
import { Trade } from '@paradigm/features/src/unified-rfqs/entities/shared';
import DrfqTradeRecapModal from '#/components/UnifiedRfqs/drfq/trade-recap/TradeRecapModal';
import GrfqTradeDetailsModal from '#/components/UnifiedRfqs/grfq/trade-recap/TradeRecapModal';
import {
  useContextMenuActions,
  useContextMenuView,
} from '#/components/UnifiedRfqs/context-menu/context-menu';
import { RfqProvider } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';

const MODAL_WIDTH = 750;

export default function TradeDetails() {
  const { detailsItemId: tradeId } = useContextMenuView();

  if (tradeId == null) return <NoTradeFound />;

  return <TradeDetailsModal tradeId={tradeId} />;
}

function TradeDetailsModal({ tradeId }: { tradeId: Trade['id'] }) {
  const trade = useMaybeTradeTapeItem(tradeId);
  const { isItemDetailsOpen } = useContextMenuView();
  const { closeDetailsModal } = useContextMenuActions();

  if (trade == null) return <NoTradeFound />;

  if (trade.rfqType === 'grfq')
    return (
      <GrfqTradeProvider trade={trade}>
        <TradeDetailsProvider tradeId={trade.id}>
          <GrfqTradeDetailsModal
            isOpen={isItemDetailsOpen}
            close={closeDetailsModal}
          />
        </TradeDetailsProvider>
      </GrfqTradeProvider>
    );

  return (
    <RfqProvider rfqId={trade.rfq_id}>
      <DrfqTradeRecapModal
        trade={trade}
        isOpen={isItemDetailsOpen}
        close={closeDetailsModal}
      />
    </RfqProvider>
  );
}

function NoTradeFound() {
  const { isItemDetailsOpen } = useContextMenuView();
  const { closeDetailsModal: closeRfqDetails } = useContextMenuActions();
  return (
    <HeadedModal
      title="Trade Recap"
      isOpen={isItemDetailsOpen}
      close={closeRfqDetails}
      width={MODAL_WIDTH}
    >
      <p css="color: red; margin: 2rem; text-align: center">
        Trade not found 😓
      </p>
    </HeadedModal>
  );
}
